import { Loader, Pill, styled } from "@monolith-forensics/monolith-ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { File } from "../../files.types";
import { FilesAPI } from "../../files.api";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export const SharedWithComponent: React.FC<{ item: File }> = ({ item }) => {
  const queryClient = useQueryClient();

  const { data, refetch } = useQuery({
    queryKey: ["case-files:shared-with", { uuid: item.uuid }],
    queryFn: () => FilesAPI.getShareDetails({ uuid: item.uuid }),
  });

  const removeUser = useMutation({
    mutationFn: (email: string) =>
      FilesAPI.unShareItems({ uuid: item.uuid, email }),
    onMutate: (email) => {
      queryClient.setQueryData(
        ["case-files:shared-with", { uuid: item.uuid }],
        (old: any) => {
          return {
            ...old,
            data:
              old?.data?.filter?.((i: any) => i.shared_with_email !== email) ||
              [],
          };
        }
      );
      return email;
    },
    onSuccess: (data, email) => {
      refetch();
    },
    onError: (error, variables, context) => {
      console.log("Error", error);
    },
  });

  if (!data) return <Loader />;

  const emails = data?.data?.map((item: any) => item.shared_with_email) || [];

  return (
    <StyledContainer>
      {emails.map((email: string) => {
        return <Pill onRemove={() => removeUser.mutate(email)}>{email}</Pill>;
      })}
    </StyledContainer>
  );
};
